import { render, staticRenderFns } from "./addExtraPriceModal.vue?vue&type=template&id=6d89533a&"
import script from "./addExtraPriceModal.vue?vue&type=script&lang=js&"
export * from "./addExtraPriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports